import React from 'react'
import { styled } from '@mui/material/styles';
import Controls from './Controls';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import SnackbarUtils from '../SnackbarUtils';
import excelService from 'services/excelService';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const CSV_TYPE = 'text/csv;application/vnd.ms-excel';

export default function UploadFile(props) {
    const styleDefault = {
        width: 'auto',
        display: 'inline-flex',
        height: 'auto'
    }

    const { acceptFiles = ".csv,.xlsx", name, layoutImport, importType, extractImportedData,
        sx, text, size, color, variant, disabled = false, outLoading, estilo = styleDefault,
        ...other } = props

    const [loading, setLoading] = React.useState(false);

    React.useEffect(async () => {
        if (outLoading > 0) {
            setLoading(false);
        }
    }, [outLoading]);

    const Input = styled('input')({
        display: 'none',
    });

    const selectFile = async (event) => {
        setLoading(true);
        // await delay(3000);
        await uploadFile(event.target.files[0]);
    }

    async function delay(ms) {
        return new Promise( resolve => setTimeout(resolve, ms) );
    }

    async function uploadFile(file) {
        // file.inProgress = true;
        // this.alertModal.showProgressSpinnerUntilExecuted();

        const fileType = file.type;

        if (EXCEL_TYPE.toLocaleLowerCase().includes(fileType.toLocaleLowerCase()) ||
            CSV_TYPE.toLocaleLowerCase().includes(fileType.toLocaleLowerCase())) {
            // this.importedData(file, this.classConteudo, 0);
            if (importType === 'data') {
                await getImportedData(file, 0);
            } else if (importType === 'json') {
                await getImportedJson(file, 0);
            }
            // this.removeFileFromArray(file);
        } else {
            // this.alertModal.closeProgressSpinnerUntilExecuted();
            SnackbarUtils.error(`Extensão do Arquivo inválida. Extensão Esperada '.xlsx' ou '.csv'`);
            // this.removeFileFromArray(file);
        }
    }

    async function getImportedData(file, sheet) {
        const reader = new FileReader();
        reader.onload = (e) => {

            const bstr = e.target.result;
            const data = excelService.importFromFile(bstr, sheet);

            const header = Object.getOwnPropertyNames(layoutImport);
            const importedData = data.slice(1);

            let erro = false;
            // Valida Header
            if (data && data[0]) {
                for (let i = 0; i < header.length; i++) {
                    if (header[i] !== data[0][i]) {
                        SnackbarUtils.error(`Layout do Arquivo inválido. Coluna esperada '${header[i]}', coluna existente '${data[0][i]}'`);
                        erro = true;
                        setLoading(false);
                        break;
                    }
                }
            }

            if (!erro) {
                const importData = importedData.map(arr => {
                    const obj = {};
                    for (let i = 0; i < header.length; i++) {
                        const k = header[i];
                        obj[k] = arr[i];
                    }
                    return obj;
                });

                const fileUpload = {
                    file: file,
                    importData: importData
                }

                extractImportedData(fileUpload);
            }
        };

        reader.readAsBinaryString(file);
    }

    async function getImportedJson(file, sheet) {
        const reader = new FileReader();
        reader.onload = (e) => {
            const bstr = e.target.result;
            const data = excelService.importFromFile(bstr, sheet);

            extractImportedData(data);
        };

        reader.readAsBinaryString(file);
    }

    return (
        <div style={estilo}>
            <label htmlFor={`contained-button-file-${name}`}>
                <Input accept={acceptFiles} id={`contained-button-file-${name}`} type="file"
                    onChange={selectFile} disabled={disabled} />
                <Controls.ButtonKml
                    style={sx}
                    variant={variant}
                    color={color}
                    startIcon={<FileUploadIcon />}
                    text={text}
                    component="span"
                    disabled={disabled}
                />
            </label>
            <Controls.DialogSpinner open={loading} />
        </div>
    )
}
